
































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { App26InputFormFacade } from './App26Facade';

const API = '/api-py/fulfillment-report/app-26';

@Component
export default class ApplicationForm26 extends Vue {
    @Prop({ required: true }) private currForm!: any;
    @Prop({ default: false })  private editAccess!: boolean;
    @Prop({ default: 'ru' })   private userLocale!: string;

    private loading   = false;
    private isDirty   = false;
    private activities: any[]  = [];
    private npaList:   any[]  = [];
    private hasBpChanges = false;
    private noBpVersion  = false;
    private bpBannerDismissed = false;
    private deletedActivityIds: number[] = [];

    private modal = {
        visible: false,
        title: '',
        titleRu: '',
        titleKk: '',
        activity: null as any,
        field: '' as string,
        valueRu: '',
        valueKk: '',
    };

    // ── lifecycle ──────────────────────────────────────────────────────────────

    async created() {
        await this.loadData();
        this.registerFacade();
    }

    // ── computed ───────────────────────────────────────────────────────────────

    get locale(): string {
        return (this.$i18n as any).locale || this.userLocale || 'ru';
    }

    get npaOptions(): any[] {
        return this.npaList
            .filter((n: any) => !n.disabled)
            .map((n: any) => ({
                value: n.id,
                text: this.locale === 'kk' ? (n.name_kk || n.name_ru) : n.name_ru,
            }));
    }

    public availableNpaOptions(act: any, currentPost: any): any[] {
        const usedIds = new Set<number>(
            (act.posts || [])
                .filter((p: any) => !p.is_deleted && p !== currentPost && p.npa_id)
                .map((p: any) => p.npa_id as number),
        );
        const options = this.npaOptions.filter((opt: any) => !usedIds.has(opt.value));
        // НПА мог потерять признак «постановление» — он попадает в npaList с disabled:true,
        // но отфильтровывается из npaOptions. Возвращаем его в список текущего поста,
        // чтобы название отображалось в дропдауне (disabled — нельзя выбрать повторно).
        if (currentPost.npa_id && !options.some((o: any) => o.value === currentPost.npa_id)) {
            const npa = this.npaList.find((n: any) => n.id === currentPost.npa_id);
            if (npa) {
                options.unshift({
                    value: npa.id,
                    text: this.locale === 'kk' ? (npa.name_kk || npa.name_ru) : npa.name_ru,
                    disabled: true,
                });
            }
        }
        return options;
    }

    get totalPlan(): number {
        return this.activities.reduce((s, a) => s + this.actPlan(a), 0);
    }

    get totalFact(): number {
        return this.activities.reduce((s, a) => s + this.actFact(a), 0);
    }

    get totalPct(): number {
        return this.totalPlan ? Math.round(this.totalFact / this.totalPlan * 10000) / 100 : 0;
    }

    get totalNonexec(): number {
        return Math.round((this.totalFact - this.totalPlan) * 10) / 10;
    }

    private activitiesVisible = true;

    get allExpanded(): boolean {
        return this.activitiesVisible;
    }

    // ── helpers ────────────────────────────────────────────────────────────────

    private activityName(act: any): string {
        return (this.locale === 'kk' ? act.name_kk : act.name_ru) || act.name_ru || '';
    }

    private activePosts(act: any): any[] {
        return (act.posts || []).filter((p: any) => !p.is_deleted);
    }

    private actPlan(act: any): number {
        return this.activePosts(act).reduce((s: number, p: any) => s + (Number(p.plan) || 0), 0);
    }

    private actFact(act: any): number {
        return this.activePosts(act).reduce((s: number, p: any) => s + (Number(p.fact) || 0), 0);
    }

    private actPct(act: any): number {
        const plan = this.actPlan(act);
        return plan ? Math.round(this.actFact(act) / plan * 10000) / 100 : 0;
    }

    private actNonexec(act: any): number {
        return Math.round((this.actFact(act) - this.actPlan(act)) * 10) / 10;
    }

    private postPct(post: any): number {
        return post.plan ? Math.round(post.fact / post.plan * 10000) / 100 : 0;
    }

    private postNonexec(post: any): number {
        return Math.round((post.fact - post.plan) * 10) / 10;
    }

    private npaName(id: number): string {
        const n = this.npaList.find(x => x.id === id);
        if (!n) return String(id);
        return this.locale === 'kk' ? (n.name_kk || n.name_ru) : n.name_ru;
    }

    // ── actions ────────────────────────────────────────────────────────────────

    private async loadData() {
        this.loading = true;
        try {
            const resp = await axios.post(`${API}/data`, {
                currForm: this.currForm,
                user_id: this.currForm.user_id,
            });
            if (resp.status === 200) {
                const d = resp.data;
                this.hasBpChanges = d.has_bp_changes;
                this.noBpVersion  = d.no_bp_version;
                this.npaList      = d.npa_list || [];
                this.activities   = (d.activities || []).map((a: any) => ({
                    ...a,
                    _open: false,
                    posts: (a.posts || []).map((p: any) => ({ ...p, _selected: false })),
                }));
                this.isDirty = false;
            }
        } finally {
            this.loading = false;
        }
        await this.updateFormFlk();
    }

    public async saveData() {
        const resp = await axios.post(`${API}/data/save`, {
            currForm: this.currForm,
            user_id: this.currForm.user_id,
            activities: this.activities,
            deleted_activity_ids: this.deletedActivityIds,
        });
        if (resp.status === 200) {
            this.deletedActivityIds = [];
            this.isDirty = false;
            this.$bvToast.toast(
                this.$t('modules.budget_execution_monitoring.reports.app26.saved') as string,
                { title: '', variant: 'success', autoHideDelay: 3000, toaster: 'b-toaster-top-center' }
            );
            await this.loadData();
            await this.updateFormFlk();
        }
    }

    public async updateBp() {
        const resp = await axios.post(`${API}/data/update-bp`, {
            currForm: this.currForm,
            user_id: this.currForm.user_id,
        });
        if (resp.status === 200 && resp.data.success) {
            const allActivities: any[] = resp.data.activities || [];
            // Применяем к локальному состоянию БЕЗ записи в БД
            this.activities = allActivities
                .filter((a: any) => !a.is_deleted)
                .map((a: any) => ({ ...a, _open: false, posts: a.posts || [] }));
            this.deletedActivityIds = allActivities
                .filter((a: any) => a.is_deleted && a.id)
                .map((a: any) => a.id as number);
            this.hasBpChanges = false;
            this.isDirty = true;
        } else {
            const msg = resp.data.no_variant
                ? this.$t('modules.budget_execution_monitoring.reports.app26.update_bp_no_variant') as string
                : resp.data.message || 'Ошибка обновления';
            this.$bvToast.toast(
                msg,
                { variant: 'warning', toaster: 'b-toaster-top-center', autoHideDelay: 4000 }
            );
        }
    }

    public async downloadReport(locale?: string) {
        const loc = locale || this.locale;
        const resp = await axios.post(
            `${API}/report`,
            { currForm: this.currForm, locale: loc },
            { responseType: 'blob' }
        );
        const url = URL.createObjectURL(new Blob([resp.data]));
        const a   = document.createElement('a');
        a.href     = url;
        const prefix = loc === 'kk' ? 'Қосымша 26' : 'Приложение 26';
        a.download = `${prefix}_${this.currForm.year}_${String(this.currForm.month + 1).padStart(2, '0')}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    }

    private addPost(act: any) {
        if (!act.posts) act.posts = [];
        act.posts.push({ id: null, npa_id: null, plan: 0, fact: 0, is_deleted: false, _selected: false });
        this.isDirty = true;
    }

    private async removePost(post: any) {
        const base = 'modules.budget_execution_monitoring.reports.app26.';
        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t(base + 'confirm_delete_row') as string,
            {
                title: this.$t(base + 'confirm_title') as string,
                okVariant: 'danger',
                okTitle: this.$t(base + 'btn_delete') as string,
                cancelTitle: this.$t('modules.common.cancel') as string,
                centered: true,
                buttonSize: 'sm',
            }
        );
        if (!confirmed) return;
        post.is_deleted = true;
        this.isDirty = true;
    }

    public allPostsSelected(act: any): boolean {
        const posts = this.activePosts(act);
        return posts.length > 0 && posts.every((p: any) => p._selected);
    }

    public hasSelected(act: any): boolean {
        return this.activePosts(act).some((p: any) => p._selected);
    }

    public toggleAllPosts(act: any, checked: boolean) {
        this.activePosts(act).forEach((p: any) => { p._selected = checked; });
        this.$forceUpdate();
    }

    public async bulkDelete(act: any) {
        if (!this.hasSelected(act)) return;
        const base = 'modules.budget_execution_monitoring.reports.app26.';
        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t(base + 'confirm_delete_row') as string,
            {
                title: this.$t(base + 'confirm_title') as string,
                okVariant: 'danger',
                okTitle: this.$t(base + 'btn_delete') as string,
                cancelTitle: this.$t('modules.common.cancel') as string,
                centered: true,
                buttonSize: 'sm',
            }
        );
        if (!confirmed) return;
        this.activePosts(act)
            .filter((p: any) => p._selected)
            .forEach((p: any) => { p.is_deleted = true; p._selected = false; });
        this.isDirty = true;
    }

    private openModal(act: any, field: string, keySuffix: string) {
        const base = 'modules.budget_execution_monitoring.reports.app26.';
        const msgs = (this.$i18n as any).messages || {};
        const path = (base + keySuffix).split('.');
        const resolve = (obj: any) =>
            path.reduce((o: any, p: string) => (o && o[p] !== undefined ? o[p] : ''), obj);
        const titleRu = (resolve(msgs.ru || {}) as string) || this.$t(base + keySuffix) as string;
        const titleKk = (resolve(msgs.kk || {}) as string) || titleRu;

        const val = act[field] || {};
        this.modal = {
            visible: true,
            title: this.locale === 'kk' ? titleKk : titleRu,
            titleRu,
            titleKk,
            activity: act,
            field,
            valueRu: val.ru || '',
            valueKk: val.kk || '',
        };
    }

    private saveModal() {
        if (this.modal.activity) {
            this.modal.activity[this.modal.field] = {
                ru: this.modal.valueRu,
                kk: this.modal.valueKk,
            };
            this.isDirty = true;
        }
        this.modal.visible = false;
    }

    private resetModal() {
        this.modal = { visible: false, title: '', titleRu: '', titleKk: '', activity: null, field: '', valueRu: '', valueKk: '' };
    }

    private markDirty() {
        this.isDirty = true;
    }

    public toggleAll() {
        this.activitiesVisible = !this.activitiesVisible;
    }

    private flkAgree(): boolean {
        if (!this.activities.length) return false;
        // Мероприятия без постов и с нулевыми суммами не блокируют FLK
        // FLK failing condition: есть пост без выбранного НПА
        return this.activities.every(act => {
            const activePosts = (act.posts || []).filter((p: any) => !p.is_deleted);
            if (!activePosts.length) return true; // пустое мероприятие — ОК
            return activePosts.every((p: any) => p.npa_id !== null);
        });
    }

    private async updateFormFlk(): Promise<void> {
        const req: any = {
            flk: !this.flkAgree(),
            form_id: this.currForm.id,
        };
        await axios.post('/api-py/input-forms/flk', req).catch(() => {});
    }

    public async handleBack(): Promise<boolean> {
        if (!this.isDirty) return true;
        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.reports.app26.unsaved_warning') as string,
            {
                title: this.$t('modules.common.attention') as string,
                okVariant: 'danger',
                okTitle: this.$t('modules.budget_execution_monitoring.reports.app26.exit_without_save') as string,
                cancelVariant: 'primary',
                cancelTitle: this.$t('modules.budget_execution_monitoring.reports.app26.stay') as string,
                centered: true,
            }
        );
        return !!confirmed;
    }

    @Watch('$i18n.locale')
    private onLocaleChange() {
        this.$nextTick(() => this.registerFacade());
    }

    private registerFacade() {
        const facade = new App26InputFormFacade();
        facade.saveData    = this.saveData.bind(this);
        facade.updateBp    = this.updateBp.bind(this);
        facade.onBackFn    = this.handleBack.bind(this);
        facade.downloadList = [
            { name: this.$t('modules.budget_execution_monitoring.reports.app26.report_name') as string, fn: () => this.downloadReport(this.locale), args: [], idx: 1 },
        ];
        this.$emit('onRegisterFacade', facade);
    }
}
